import styled from 'styled-components';
import { FullWidth } from 'ui/utility/fullWidth';
import { SecondaryPageHeader } from 'ui/pageHeader';
import { backgroundColors, spacing } from 'ui/theme';
import { layoutLRPadding } from 'ui/theme/spacing';
import { pxToRem } from 'utils/convert';

export const StyledSecondaryPageHeader = styled(SecondaryPageHeader)`
  align-items: flex-end;
`;

export const Layout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing.double};
  margin-top: ${spacing.x3};

  @media (min-width: ${pxToRem(720)}) {
    grid-template-columns: minmax(auto, ${pxToRem(320)}) 1fr;
  }
`;

export const StyledFullWidth = styled(FullWidth)`
  padding-right: ${layoutLRPadding};
  padding-left: ${layoutLRPadding};
  background-color: ${backgroundColors.backgroundSecondary};
`;
